const content: { [key: string]: any } = {
  permissionFeatureList: 'Features',
};

export default content;
